
  import { mapGetters,mapActions } from 'vuex'
  export default {
    props:{
      region:{
        type:String,
        default:'UK',
      },
    },
    computed: {
      ...mapGetters({
        activeModal : 'pages/getActiveModal',
      }),
      backgroundStyles() {
        const imgUrl = this.$img('https://cdn-wp.tefl.org/wp-content/uploads/2024/01/homepage-quiz-bg.jpg', { width: '100%',format:'webp',quality:70 })
        return {
          backgroundImage: `url('${imgUrl}')`
        }
      },
    },
    methods:{
        ...mapActions({
          updateActiveModal: 'pages/updateActiveModal', // map `this.add()` to `this.$store.commit('increment')`
        }),
        updateModal(id){
          this.updateActiveModal(id)
          console.log('Active Modal: ',this.activeModal)
        }
    },
  }
  